// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"510":"52dc93e1","847":"298a3cb9"}[chunkId] + ".chunk.css";
};